export default __webpack_public_path__ + "static/media/Logo.536c1fa5.svg";